import React from 'react';
import ImageUploader from './ImageUploader';
import { UploadedImage } from '../CommonTypes';
import { useTranslation } from 'react-i18next';

const FormImageUploader = ({
    id,
    name,
    label,
    image,
    exampleImage,
    onImageChange
}: {
    id: string;
    name: string;
    label: string;
    image?: UploadedImage;
    exampleImage?: {
        label: string;
        src: string;
        id?: string; // for old auto tests selectors compatibility
    };
    onImageChange: (
        imageType: string,
        uploadedPath: string,
        imageId: string,
        image: string,
        filename: string
    ) => void;
}) => {
    const { t } = useTranslation();
    return (
        <div
            id={`form-image-uploader-${id}`}
            data-testid={`form-image-uploader-${id}`}
            className='images-wrapper'>
            {exampleImage && (
                <div className='image-wrapper'>
                    <p
                        className='example-image-text'
                        data-testid='example-label'
                        style={{
                            textAlign: 'center',
                            fontWeight: 'bold'
                        }}>
                        {exampleImage.label}
                    </p>
                    <img
                        className='example-images'
                        id={exampleImage.id}
                        data-testid='example-image'
                        src={exampleImage.src}
                        alt={name}
                    />
                </div>
            )}
            <div className='image-wrapper'>
                <div className='image-preview'>
                    <div className='image-preview-header'>{label}</div>
                    <div className='image-preview-content'>
                        <ImageUploader
                            name={`${id}-preview`}
                            title={t('upload_image')}
                            UploadedImage={image}
                            onImageChange={onImageChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormImageUploader;
